import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssetTransferApproveRoutingModule } from './asset-transfer-approve-routing.module';
import { AssetTransferApproveLinkComponent } from './asset-transfer-approve-link/asset-transfer-approve-link.component';
import { AssetTransferApproveLandingPageComponent } from './asset-transfer-approve-landing-page/asset-transfer-approve-landing-page.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { AssetTransferApproveDetailsComponent } from './asset-transfer-approve-details/asset-transfer-approve-details.component';
import { AssetTransferStepperComponent } from './asset-transfer-stepper/asset-transfer-stepper.component';
import { MatStepperModule } from '@angular/material/stepper';
import { DialogApprovedMessageComponent } from './dialog-approved-message/dialog-approved-message.component';
import { DialogRejectMessageComponent } from './dialog-reject-message/dialog-reject-message.component';




@NgModule({
  declarations: [
    AssetTransferApproveLinkComponent,
    AssetTransferApproveLandingPageComponent,
    AssetTransferApproveDetailsComponent,
    AssetTransferStepperComponent,
    DialogApprovedMessageComponent,
    DialogRejectMessageComponent,


  ],
  imports: [
    CommonModule,
    AssetTransferApproveRoutingModule,
    AcademicFormModule,
    MatStepperModule

  ]
})
export class AssetTransferApproveModule { }
